'use client'

import { FC, useState } from 'react'

import { DocKey, docsManifest } from 'src/docs/generated/docsManifest'

import { Icon } from '../../basicUI/Icon'
import { Tooltip } from '../../basicUI/Tooltip'
import { CSS } from '../../stitches.config'
import { FieldDocModal } from './FieldDocModal'

export interface FieldDocTriggerProps {
  docKey: DocKey
  css?: CSS
}

/**
 * Info icon rendered next to a field label: hover shows the doc summary,
 * click opens the full documentation modal.
 */
export const FieldDocTrigger: FC<FieldDocTriggerProps> = ({ docKey, css }) => {
  const [open, setOpen] = useState(false)
  const doc = docsManifest[docKey]

  return (
    <>
      <Tooltip content={doc.summary} maxWidth="360px" useSpanElementForTrigger={true}>
        <Icon
          name="info"
          type="outlined"
          size={16}
          pointer={true}
          onClick={e => {
            e.preventDefault()
            e.stopPropagation()
            setOpen(true)
          }}
          css={{ color: '$gs10', '&:hover': { color: '$gs12' }, verticalAlign: 'middle', ...css }}
        />
      </Tooltip>
      {open && <FieldDocModal docKey={docKey} open={open} onOpenChange={setOpen} />}
    </>
  )
}
